import { TweenLite, TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from 'scrollmagic';
import ScrollMagicController from '../class/ScrollMagicController';
import { Expo } from 'gsap/gsap-core';

class Mainstay {
	constructor() {
		this.sections = document.querySelectorAll('.presentation');
		// this.animate();
		this.activeModal();
	}
	activeModal() {
		const modals = document.getElementsByClassName('mainstay-modal');
		const btns = document.getElementsByClassName('mainstay-content__block');
		const spans = document.getElementsByClassName('close');
		for (let i = 0; i < btns.length; i++) {
			btns[i].onclick = function () {
				modals[i].style.display = 'block';
			};
			window.addEventListener('click', function (event) {
				if (event.target == modals[i]) {
					modals[i].style.display = 'none';
				}
			});
		}
		for (let i = 0; i < spans.length; i++) {
			spans[i].onclick = function () {
				modals[i - 1].style.display = 'none';
			};
		}
	}
	animate() {
		this.sections.forEach((section) => {
			const timeline = new TimelineLite();

			const title = section.querySelectorAll('.title, .surtitle');
			if (title.length) {
				const titleAnimation = TweenMax.staggerFromTo(
					title,
					0.3,
					{ y: 150, autoAlpha: 0 },
					{ y: 0, autoAlpha: 1 },
					0.1
				);
				timeline.add(titleAnimation);
			}

			const blocks = section.querySelector('.presentation-content');
			if (blocks) {
				const blocksAnimation = TweenMax.fromTo(blocks, 0.3, { y: 150, autoAlpha: 0 }, { y: 0, autoAlpha: 1 });
				timeline.add(blocksAnimation);
			}

			const button = section.querySelector('.presentation__cta-wrapper--cta-right .cta');
			if (button) {
				const buttonAnimation = TweenMax.fromTo(button, 0.3, { x: 300, autoAlpha: 0 }, { x: 0, autoAlpha: 1 });
				timeline.add(buttonAnimation);
			}

			new ScrollMagic.Scene({
				triggerElement: section,
				triggerHook: 0.85,
				offset: 0,
				reverse: false,
			})
				.setTween(timeline)
				.addTo(ScrollMagicController.controller);
		});
	}
}

export default Mainstay;
